































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TopNavigationComponent from "./TopNavigation.vue";
import LiveSummaryComponent from "./LiveSummary.vue";

const namespace: string = "assessmentForm";

@Component({
  components: {
    TopNavigationComponent,
    LiveSummaryComponent
  }
})
export default class SubmitComponent extends Vue {
  @Prop() schema: any;
  @Prop() model: any;

  mounted() {}

  get appModel() {
    return this.model;
  }
}
